export const getToken = (state = {}) => state.auth.authToken;